import Sessions from './Sessions'
import TimeSlots from './TimeSlots'
import CollectInformation from './CollectInformation'
import Confirmation from './Confirmation'
import Receipt from './Receipt'
import Payment from './Payment'

export {
    Sessions,
    TimeSlots,
    CollectInformation,
    Confirmation,
    Receipt,
    Payment
}


// WEBPACK FOOTER //
// ./components/templates/index.js